import React, { useState } from "react";
import { addClientTouch, getClientWork } from "../../api/paidClientsService";
import useClientData from "../../hooks/useClientData";
import { CHURN_REASONS, TOUCH_CHANNELS } from "../../utils/constants";
import { fmtDateTime } from "../../utils/format";
import { StageTag } from "../PaidClientsTable";
import { AmoLinkEditor, TabState } from "../common";

const FLAG_LABELS = {
  expiring: "истекает",
  silent: "молчит",
  beta: "бета PRO+",
};

const WorkTab = ({ userId, detail, patch, notify }) => {
  const { data, setData, loading, error } = useClientData(getClientWork, userId);
  const [channel, setChannel] = useState("call");
  const [text, setText] = useState("");
  const [saving, setSaving] = useState(false);

  const patchWork = async (fields, message) => {
    if (await patch(fields, message)) setData((prev) => ({ ...(prev || {}), ...fields }));
  };

  const saveTouch = async () => {
    if (!text.trim()) return;
    setSaving(true);
    try {
      const touch = await addClientTouch(userId, channel, text.trim());
      setData((prev) => ({ ...(prev || {}), touches: [touch, ...(prev?.touches || [])] }));
      setText("");
      notify("Касание сохранено");
    } catch (e) {
      notify(e.message);
    } finally {
      setSaving(false);
    }
  };

  const amoCrmUrl = data?.amoCrmUrl ?? null;
  const flags = data?.flags || [];
  const touches = data?.touches || []; // новые сверху

  return (
    <TabState loading={loading} error={error} data={data}>
      <div className="pc-card">
        <h3>Этап, флаги и AmoCRM</h3>
        <div className="pc-kv">
          <div className="k">Текущий этап</div>
          <span>
            <StageTag stage={data?.stage ?? detail.stage} />
          </span>

          <div className="k">Активные флаги</div>
          <div className="pc-row">
            {flags.length ? (
              flags.map((f) => (
                <span key={f} className="tag acc">
                  {FLAG_LABELS[f] || f}
                </span>
              ))
            ) : (
              <span className="muted">нет</span>
            )}
          </div>

          {data?.isExpired && (
            <>
              <div className="k">Причина непродления</div>
              <select
                className="pc-select"
                value={data?.churnReason || ""}
                onChange={(e) =>
                  patchWork({ churnReason: e.target.value || null }, "Причина непродления сохранена")
                }
              >
                <option value="">Не указана</option>
                {Object.entries(CHURN_REASONS).map(([k, l]) => (
                  <option key={k} value={k}>
                    {l}
                  </option>
                ))}
              </select>
            </>
          )}

          <div className="k">Карточка в AmoCRM</div>
          <AmoLinkEditor
            url={amoCrmUrl}
            openLabel="Открыть карточку в AmoCRM ↗"
            onSave={(url) => patchWork({ amoCrmUrl: url }, "Ссылка AmoCRM сохранена")}
          />
        </div>
      </div>

      <div className="pc-card">
        <h3>Касания</h3>
        <div className="pc-row" style={{ marginBottom: 8 }}>
          {Object.entries(TOUCH_CHANNELS).map(([k, l]) => (
            <button
              key={k}
              type="button"
              className={`pc-chip ${channel === k ? "on" : ""}`}
              onClick={() => setChannel(k)}
            >
              {l}
            </button>
          ))}
        </div>
        <textarea
          className="pc-textarea"
          maxLength={4000}
          placeholder="Заметка о клиенте, какой БИН/ниша, итог разговора..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <div style={{ marginTop: 8 }}>
          <button
            type="button"
            className="pc-btn primary"
            onClick={saveTouch}
            disabled={saving || !text.trim()}
          >
            Сохранить касание
          </button>
        </div>

        <div style={{ marginTop: 14 }}>
          {touches.length ? (
            touches.map((t, i) => (
              <div className="pc-touch" key={t.id || i}>
                {t.text}
                <small>
                  {fmtDateTime(t.at)}
                  {t.authorName && ` · ${t.authorName}`} · {TOUCH_CHANNELS[t.channel] || t.channel}
                </small>
              </div>
            ))
          ) : (
            <div className="muted">Касаний пока нет</div>
          )}
        </div>
      </div>
    </TabState>
  );
};

export default WorkTab;
